import { render, staticRenderFns } from "./DeliveryTimeInner.vue?vue&type=template&id=734b0f69&"
import script from "./DeliveryTimeInner.vue?vue&type=script&lang=js&"
export * from "./DeliveryTimeInner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports